import React from 'react';
import { useContextSelector } from 'use-context-selector';
import Modal from 'react-modal';

import styles from './ConfirmDialog.module.scss';
import { UIContext } from '../../context/UI/UIContext';
import Icon from '../Icon/Icon';
import Button from '../Button/Button';

function ConfirmDialog() {
  const {
    onConfirm,
    onClickOutside,
    isOpen,
    title,
    description,
    cancelLabel,
    confirmLabel,
    type,
    confirmClassName,
    cancelClassName,
  } = useContextSelector(UIContext, (c) => c.confirmModal);
  const hideConfirm = useContextSelector(UIContext, (c) => c.hideConfirm);
  const success = type === 'success';
  const danger = type === 'danger';

  function handleCancel() {
    onClickOutside && onClickOutside();
    hideConfirm();
  }

  function handleConfirm() {
    onConfirm && onConfirm();
    hideConfirm();
  }

  return (
    <Modal
      isOpen={!!isOpen}
      onRequestClose={handleCancel}
      className={styles.content}
      overlayClassName={styles.overlay}
      portalClassName={styles.portal}
      ariaHideApp={false}
    >
      <div
        className={[
          styles.ConfirmDialog,
          success && styles.ConfirmDialogSuccess,
          danger && styles.ConfirmDialogDanger,
        ].join(' ')}
      >
        {(success || danger) && <Icon icon="times" />}
        {title && <h2>{title}</h2>}
        {description && <p>{description}</p>}
        <div>
          <Button
            size="small"
            cancel
            onClick={handleCancel}
            className={cancelClassName}
            testId="buttonConfirmDialogCancel"
          >
            {cancelLabel || 'Cancel'}
          </Button>
          <Button
            size="small"
            success={success}
            danger={danger}
            onClick={handleConfirm}
            className={confirmClassName}
            testId="buttonConfirmDialogConfirm"
          >
            {confirmLabel || 'Confirm'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
